import * as api from "../../../APICalls/index";

type formDataType = {
  password: string;
  email?: string;
  token: string;
  type?: string;
};

const getAuthErrorMessage = (error: any, fallbackMessage: string) => {
  const status = error?.response?.status;
  const data = error?.response?.data;

  const message =
    data?.message ||
    data?.error ||
    (typeof data === "string" ? data : "") ||
    (status === 404
      ? "Password reset is not available in this environment."
      : fallbackMessage);

  return {
    message,
    status,
  };
};

export const resetPassword = (formData: formDataType) => async () => {
  try {
    const payload = {
      ...formData,
      email: formData.email?.toLowerCase().trim(),
      token: formData.token.trim(),
      type: formData.type ?? "otp",
    };
    const response = await api.ResetPassword(payload);

    if (response.status === 200) {
      let result = {
        data: response.data,
        success: true,
        message: "Password Reset Successfully",
      };

      return result;
    }
    return {
      data: response.data,
      success: false,
      message: response.data?.message || "Password reset failed.",
    };
  } catch (error: any) {
    const { message, status } = getAuthErrorMessage(
      error,
      "Password reset failed."
    );

    let result = {
      success: false,
      error: "Password reset failed",
      message,
      status,
    };

    return result;
  }
};
